"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var text_1 = require("./text");
function LettersDirective($timeout, config, book, glyphMatcher) {
    'ngInject';
    return {
        templateUrl: config.params.base + 'templates/form/options/letters.html',
        controller: /** @class */ (function (_super) {
            __extends(LettersController, _super);
            function LettersController($scope, book) {
                return _super.call(this, $scope, book) || this;
            }
            LettersController.prototype.onChange = function () {
                _super.prototype.onChange.call(this);
                glyphMatcher.update(this.prefix, this.id, this.form.value);
            };
            return LettersController;
        }(text_1.TextController)),
        controllerAs: 'lettersCtrl'
    };
}
exports.LettersDirective = LettersDirective;
